import axios from 'axios'
import router from '@/router'
import { useUserStore } from '@/store/user'
import store from '@/store'

const instance = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
})

let isLoggingOut = false

instance.interceptors.response.use(
    response => response,

    async error => {
        const status = error?.response?.status

        switch (status) {
            case 401:


                if (isLoggingOut) {
                    return Promise.reject(error)
                }

                isLoggingOut = true

                try {
                    const token = localStorage.getItem('token')


                    if (token) {
                        await axios.post(
                            `${window.appConfig.API_URL_BASE}api/logout`,
                            {},
                            {
                                headers: {
                                    Accept: 'application/json',
                                    'Content-Type': 'application/json',
                                    Authorization: `Bearer ${token}`,
                                },
                            }
                        )
                    }
                } catch (err) {
                    console.error('Logout API Error:', err)
                } finally {
                    // پاک کردن اطلاعات کاربر
                    localStorage.removeItem('token')
                    localStorage.removeItem('panel-role')

                    store.commit('setMobile', '')
                    store.commit('setLogin', false)

                    const userStore = useUserStore()
                    userStore.clearUser()

                    if (router.currentRoute.value.path !== '/auth/login') {
                        router.replace('/auth/login')
                    }

                    isLoggingOut = false
                }

                return Promise.reject(error)

            case 403:
                if (router.currentRoute.value.name !== 'Error403') {
                   await router.replace({ name: 'Error403' })
                }
                return Promise.reject(error)

     /*       case 422:
                if (error?.response?.data?.password_must_change) {

                    await router.replace({ name: 'newPassword' })

                    return new Promise(() => {})
                }
                return new Promise(() => {})*/

            case 503:
                if (router.currentRoute.value.name !== 'Error503') {
                   await router.replace({ name: 'Error503' })
                }
                return Promise.reject(error)

            default:
                return Promise.reject(error)
        }
    }
)

export default instance
